import {getMediaURL} from '../../utils/renderMedia';

export const imageField = [
  {
    name: 'src',
    label: 'Image',
    component: 'image',
    parse: (media) => `/${media.src}`,
    uploadDir: () => '/',
    previewSrc: (src) => getMediaURL(src),
    focusRing: false,
  },
  {
    name: 'alt',
    label: 'Image alt',
    component: 'text',
  },
];

export const image = {
  name: 'media',
  label: 'Button Setting',
  component: 'group',
  fields: imageField
};


export const imageSimpleField = [
  {
    name: 'media.src',
    label: 'Image',
    component: 'image',
    parse: (media) => `/${media.src}`,
    uploadDir: () => '/',
    previewSrc: (src) => getMediaURL(src),
    focusRing: false,
  },
  {
    name: 'media.alt',
    label: 'Button alt',
    component: 'text',
  },
];
